import { faArrowsRepeat, faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { queryString } from '@olivierpascal/helpers';
import { Button, Stack } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { Sessions } from '~/components/organisms/Sessions';

export type ISessionsPageProps = {
  previousUrl?: string;
  nextUrl?: string;
  appRegion?: string;
};

export const SessionsPage: React.FC<ISessionsPageProps> = (props) => {
  const { previousUrl, nextUrl, appRegion } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('SessionsPage.seo.title')}</title>
      </Helmet>

      <Heading
        previousUrl={previousUrl}
        title={t('SessionsPage.title')}
        icon={<FontAwesomeIcon icon={faArrowsRepeat} />}
        actions={
          <Button
            href={`^/sessions/new?${queryString.build({
              nextUrl,
              previousUrl,
              appRegion,
            })}`}
            icon={<FontAwesomeIcon icon={faPlus} />}
          >
            {t('SessionsPage.action')}
          </Button>
        }
      />

      <Stack gap={4}>
        <Sessions
          previousUrl={previousUrl}
          nextUrl={nextUrl}
          appRegion={appRegion}
        />
      </Stack>
    </>
  );
};
